import React, { Component } from 'react';
import ListModifiers from './ListModifiers';
import PizzaCreatorModifiers from './components/PizzaCreatorModifiers';
import SkyLight from 'react-skylight'; // Need to install this package: npm install --save react-skylight Ref:http://marcio.github.io/react-skylight/
import { NutritionPannel } from './components/Nutrition';
import NutritionalIcon from './components/NutritionalIcon';
import windowSize from 'react-window-size';
import Loader from 'react-loader-spinner';
import { ToastContainer, ToastMessage } from '../../../../lib';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import {
  NutritionStringToObject,
  parsePrice,
  getNutritionHeader,
} from '../../../../lib/helper.js';
import {
  filterSelectedModfiers,
  validateItem,
  restrictSubmit,
  enforceAllForceModifierCount,
} from '../../actions/cartActions.js';
import StepInput from './components/StepInput';
import { get, uniqueId } from 'lodash';
import { connect } from 'react-redux';
import { getJWT, getTokenId } from '../../../../redux/reducers/authenticationReducers';
import { getDataName } from '../../reducer';
import ItemImage from './ItemImage';
import { Modal } from 'react-bootstrap';
import { OUT_OF_STOCK } from '../../../../util/Constants';
import Description from './components/Description';
import { addToTempCart } from '../../actions';
import { calculatePizzaModifierBuilderCost } from './components/PizzaCreatorModifiers/utils';
import defaultMsg from '../../../../translations/lang/en-US.json';
import { MdLoaderTheme } from '../../../common/Loading';

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

let cartItems = [];
let itemData = [];
let forcedModifiers = [];
let optionalModifiers = [];

class AddItemPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberofItems: this.props.currentItem['numberOfItems']
        ? this.props.currentItem['numberOfItems']
        : 1,
      nutritionPanelStatus: false,
      addToBagButton: true,
      specialInstructionId: 'splInstructions',
      scrollBack: 0,
      focusCounter: false,
      loadingDetour: false,
      scrollType: '',
      clickedItemIdList: [],
      enableReOrderBack: false,
      addingToCart: false,
      showSpecialInstructions: false,
      specialInstructionsData: '',
    };
    this.specialInstructionsChange = this.specialInstructionsChange.bind(this);
    this.handleModifierChange = this.handleModifierChange.bind(this);
    this.handlePizzaCreatorModifierChange = this.handlePizzaCreatorModifierChange.bind(
      this
    );
    this.addItemsToBag = this.addItemsToBag.bind(this);
    // this.handleSpecialInstruction = this.handleSpecialInstruction.bind(this);
    this.restrictSubmit = restrictSubmit.bind(this);
    this.updateModiferList = this.updateModiferList.bind(this);
    this.setNumberOfItems = this.setNumberOfItems.bind(this);
    this.onDetourUpdate = this.onDetourUpdate.bind(this);
    this.loadingMoreOptions = this.loadingMoreOptions.bind(this);
    this.pickSepecialInstruction = this.pickSepecialInstruction.bind(this);
    this.removeCI = this.removeCI.bind(this);
  }

  specialInstructionsChange(scrollback, specialInst) {
    this.setState({
      scrollBack: scrollback,
    });
  }

  removeCI() {
    this.setState({
      nutritionPanelStatus: false,
      clickedItemIdList: [],
      enableReOrderBack: 'false',
      scrollBack: 0,
    });
    this.props.removeCI();
  }

  pickSepecialInstruction() {
    let currentItem = this.props.currentItem;
    if (
      currentItem.isFromReorder === null ||
      currentItem.isFromReorder === undefined
    ) {
      if (localStorage.getItem('specialInstructions') !== '') {
        currentItem['specialInstruction'] = localStorage.getItem(
          'specialInstructions'
        );
      }
    }
    return currentItem;
  }

  parseCounter(count, filterZero) {
    const counter = Number(count);
    if (!isNaN(counter)) {
      if ((filterZero && counter < 1) || counter < 0) {
        return 1;
      }
      return counter > 100 ? 100 : counter;
    } else {
      return 1;
    }
  }

  setNumberOfItems(count) {
    this.pickSepecialInstruction();
    this.setState({
      numberofItems: count,
      focusCounter: true,
      scrollBack: this.refs.modifierList.refs.modifierContainer.scrollTop,
    });
  }

  componentDidUpdate() {
    if (this.props.currentItem !== '' && this.props.currentItem !== null) {
      this.openModal();
    }
  }

  componentWillReceiveProps(nextProps) {
    const numberOfItems = get(nextProps, 'currentItem.numberOfItems', 1);
    if (nextProps.currentItem === '') {
      this.setState({
        numberofItems: numberOfItems,
      });
    }
    if (
      nextProps.addingToCart !== undefined &&
      nextProps.addingToCart === false
    ) {
      this.setState({ addingToCart: false });
    }
  }

  openModal() {
    this.refs.aipDialog.show();
  }

  closeModal() {
    this.setState({ addToBagButton: true });
    this.refs.aipDialog.hide();
    this.setState({ currentItemClicked: '' });
    window.modalPopped = -1;
  }

  addToBagSuccess(modifierList) {
    const {
      orderTypePopupOnAddToCart,
      updateCartItem,
      addItemToBag,
      dispatch,
    } = this.props;
    const { numberofItems } = this.state;
    cartItems = [];
    itemData = [];
    forcedModifiers = [];
    optionalModifiers = [];
    let cartObj = {};
    window.modalPopped = -1;
    this.closeModal();
    let currentItem = this.pickSepecialInstruction();
    if (modifierList) {
      currentItem.forced = modifierList;
    }
    const { id } = currentItem;
    itemData.push(
      Object.assign(
        { quantity: numberofItems },
        { id },
        { name: currentItem.name },
        { forced: currentItem.forced },
        { image: encodeURIComponent(currentItem.image) }
      )
    );
    currentItem.forced.map((value, key) => {
      forcedModifiers.push(
        Object.assign(
          { quantity: numberofItems },
          { id: value.id },
          { name: value.title }
        )
      );
      value.option.map((valueOption, keyOption) => {
        if (valueOption.selected === true) {
          if (valueOption.doption) {
            this.requiredForcedModifiers(valueOption.doption);
          }
        }
      });
    });
    currentItem.optional.map((value, key) => {
      value.option.map((valueOption, keyOption) => {
        if (valueOption.selected === true) {
          optionalModifiers.push(
            Object.assign(
              { quantity: numberofItems },
              { id: value.id },
              { name: value.title }
            )
          );
        }
      });
    });
    cartObj = Object.assign(
      {},
      { item_id: itemData },
      { forced_modifier_id: forcedModifiers },
      { optional_modifier_id: optionalModifiers }
    );
    if (orderTypePopupOnAddToCart === true) {
      dispatch(
        addToTempCart({
          item: currentItem,
          count: numberofItems,
        })
      );
    } else {
      addItemToBag(currentItem, numberofItems, cartObj, updateCartItem);
    }

    this.setState({
      scrollBack: 0,
    });
  }

  requiredForcedModifiers(valueOption) {
    if (valueOption) {
      valueOption.map((dOptionValue, key) => {
        if (dOptionValue.selected && dOptionValue.selected === true)
          forcedModifiers.push(
            Object.assign(
              { quantity: this.state.numberofItems },
              { id: dOptionValue.id },
              { name: dOptionValue.title }
            )
          );
        if (dOptionValue.option) {
          dOptionValue.option.map((nestedItems, nestedKey) => {
            if (nestedItems.selected && nestedItems.selected === true)
              forcedModifiers.push(
                Object.assign(
                  { quantity: this.state.numberofItems },
                  { id: nestedItems.id },
                  { name: nestedItems.title }
                )
              );
            this.requiredForcedModifiers(nestedItems.doption);
          });
        }
      });
    }
  }

  addItemsToBag(items) {
    this.props.addItemsToBag(items);
  }
  reOrderBack() {
    this.setState({ clickedItemIdList: [], nutritionPanelStatus: false });
    this.props.backToReOrder();
  }
  editItem(reOrderItem) {
    this.setState({ enableReOrderBack: true });
    this.props.editReOrder(reOrderItem);
  }
  addToBag(e) {
    e.preventDefault();
    this.setState({
      clickedItemIdList: [],
      enableReOrderBack: 'false',
      addingToCart: true,
    });
    if (Number(this.state.numberofItems) === 0) {
      if (this.refs.addToCart) {
        this.refs.addToCart.error(
          this.props.intl.formatMessage({
            id: 'errorZeroItems',
            defaultMessage: defaultMsg.errorZeroItems,
          })
        );
      }
    } else if (
      (this.props.currentItem.isFromReorder === null ||
        this.props.currentItem.isFromReorder === undefined) &&
      this.props.currentItem.forced.length !== 0
    ) {
      const validData = validateItem(this.props.currentItem.forced);
      if (validData.status) {
        this.setState({
          focusCounter: false,
        });

        this.addToBagSuccess(validData.modifierList);
      } else if (validData.errorCount === 1) {
        this.refs.addToCart.error(
          this.props.intl.formatMessage({
            id: 'selectAtLeastOneModifier',
            defaultMessage: defaultMsg.selectAtLeastOneModifier,
          })
        );
      } else {
        this.refs.addToCart.error(
          this.props.intl.formatMessage({
            id: 'selectModifiers',
            defaultMessage: defaultMsg.selectModifiers,
          })
        );
        e.preventDefault();
      }
    } else {
      this.setState({
        focusCounter: false,
      });
      this.addToBagSuccess();
    }
  }

  switchNutritionPanel() {
    this.pickSepecialInstruction();
    this.setState({
      nutritionPanelStatus: !this.state.nutritionPanelStatus,
    });
  }
  updateModiferList(activeItem, selectedModifierList) {
    let itemPrice = 0;
    let itemNutrition = '';
    let modifierCost;
    selectedModifierList.forEach(selectedModifier => {
      modifierCost = parseFloat(parsePrice(selectedModifier.cost, true));
      //If Modifier Builder was used, the cost has to be calculated based on the selection
      if (selectedModifier.use_builder)
        modifierCost = calculatePizzaModifierBuilderCost(
          modifierCost,
          selectedModifier.selected_amount,
          selectedModifier.selected_serving
        );

      itemPrice = modifierCost + parseFloat(parsePrice(itemPrice, true));

      itemNutrition = NutritionStringToObject(
        selectedModifier.nutrition,
        itemNutrition,
        'plus'
      );
    });

    activeItem.price =
      parseFloat(parsePrice(itemPrice, true)) +
      parseFloat(parsePrice(activeItem.basePrice, true));
    activeItem.nutrition = NutritionStringToObject(
      activeItem.baseNutrition,
      itemNutrition,
      'plus'
    );
    this.props.changeModifiersFromDashboard(activeItem);
  }

  onDetourUpdate(selectedModifierList) {
    this.setState({
      loadingDetour: false,
    });
  }

  loadingMoreOptions() {
    this.setState({
      loadingDetour: true,
    });
  }
  handleModifierChange(scrollBack, event) {
    this.setState({
      scrollBack,
    });
    let activeItem = JSON.parse(JSON.stringify(this.pickSepecialInstruction()));
    let selectedModifierList = [];
    let clickedItemIdList = [];
    let elementChecked = document.querySelectorAll(
      '.pickupTimeOption input:checked'
    );
    const apiDefaultParams = {
      dataname: this.props.dataname,
      tokenId: this.props.tokenId,
      jwt: this.props.jwt,
    };

    if (elementChecked) {
      for (var j = 0; j < elementChecked.length; j++) {
        clickedItemIdList.push(elementChecked[j].id);
      }
    }

    activeItem['numberOfItems'] = this.state.numberofItems;
    this.setState({
      focusCounter: false,
    });

    if (activeItem.forced || activeItem.optional) {
      if (activeItem.forced) {
        filterSelectedModfiers(
          activeItem.forced,
          selectedModifierList,
          clickedItemIdList,
          apiDefaultParams,
          false,
          this.onDetourUpdate,
          this.loadingMoreOptions
        ).then(modifierList => {
          activeItem.forced = modifierList;
          this.updateModiferList(activeItem, selectedModifierList);
        });
      }

      if (activeItem.optional) {
        filterSelectedModfiers(
          activeItem.optional,
          selectedModifierList,
          clickedItemIdList,
          apiDefaultParams,
          false,
          this.onDetourUpdate,
          this.loadingMoreOptions
        ).then(modifierList => {
          activeItem.optional = modifierList;
          this.updateModiferList(activeItem, selectedModifierList);
        });
      }
    } else {
      this.props.changeModifiersFromDashboard(activeItem);
    }
  }

  handlePizzaCreatorModifierChange(selectedModifierList, scrollBack) {
    this.setState({ scrollBack });
    let activeItem = this.pickSepecialInstruction();
    activeItem['numberOfItems'] = this.state.numberofItems;
    this.setState({
      focusCounter: false,
    });
    this.updateModiferList(activeItem, selectedModifierList);
  }

  stepUp() {
    this.pickSepecialInstruction();
    this.setState({
      numberofItems: this.parseCounter(this.state.numberofItems + 1),
      focusCounter: false,
      scrollBack: this.refs.modifierList.refs.modifierContainer.scrollTop,
    });
  }

  stepDown() {
    this.pickSepecialInstruction();
    if (this.state.numberofItems > 1) {
      this.setState({
        numberofItems: this.state.numberofItems - 1,
      });
    }
    this.setState({
      focusCounter: false,
      scrollBack: this.refs.modifierList.refs.modifierContainer.scrollTop,
    });
  }
  validate() {
    const { currentItem } = this.props;
    return (
      validateItem(currentItem.forced).status &&
      enforceAllForceModifierCount(
        currentItem.forced,
        list => list.type_option,
        list => list.option
      ) &&
      (currentItem.use_pizza_creator
        ? enforceAllForceModifierCount(
            get(currentItem, 'pizza_creator.pizza_mods', []),
            item => item.forced_modifier_list_type_option,
            item => item.forced_modifiers
          )
        : true)
    );
  }
  render() {
    const reOrderItems = get(this.props.currentItem, 'forced', 1);
    const titleStyle = {
      fontSize: '15px',
      textAlign: 'center',
      color: '#7DA000',
    };
    let dialogStyles;
    if (this.props.windowHeight < 500) {
      dialogStyles = {
        width: '50%',
        position: 'fixed',
        top: '0',
        height: 'auto',
        marginTop: '0px',
        marginLeft: '-25%',
        backgroundColor: '#fff',
        borderRadius: '2px',
        zIndex: 100,
        paddingTop: '0px',
        paddingLeft: '0px',
        paddingRight: '0px',
        boxShadow: '0 0 4px rgba(0,0,0,.14),0 4px 8px rgba(0,0,0,.28)',
        overflow: 'scroll',
      };
    } else {
      dialogStyles = {
        width: '50%',
        position: 'fixed',
        top: '50%',
        height: 'auto',
        marginTop: '-300px',
        marginLeft: '-25%',
        backgroundColor: '#fff',
        borderRadius: '2px',
        zIndex: 100,
        paddingTop: '0px',
        paddingLeft: '0px',
        paddingRight: '0px',
        boxShadow: '0 0 4px rgba(0,0,0,.14),0 4px 8px rgba(0,0,0,.28)',
      };
    }
    const errMessage = {
      display: 'none',
    };
    const { currentItem, updateCurrentItem } = this.props;
    const nutritionList = Array.isArray(this.props.currentItem.nutrition)
      ? get(this, 'props.currentItem.nutrition', [])
      : [];
    const themeColor = '#' + this.props.themeCode;
    const itemImageData = {
      url: get(this, 'props.currentItem.images.thumbnail', ''),
      outOfStock:
        get(this, 'props.currentItem.availability', '').toLowerCase() ===
        OUT_OF_STOCK,
      imageName: get(this, 'props.currentItem.name', ''),
      imagePresent: get(this, 'props.currentItem.item_image_present', ''),
    };

    return this.props.currentItem ? (
      <div key={'skylight-modal-conatiner-'}>
        <modal>
          <ToastContainer
            toastMessageFactory={ToastMessageFactory}
            ref="addToCart"
            className="toast-top-right"
          />

          <SkyLight
            onCloseClicked={this.removeCI}
            beforeClose={this.removeCI}
            closeOnEsc={this.removeCI}
            onOverlayClicked={this.removeCI}
            id="aip"
            dialogStyles={dialogStyles}
            titleStyle={titleStyle}
            hideOnOverlayClicked
            ref="aipDialog"
          >
            <form>
              <Modal.Header>
                <Modal.Title>
                  <div className="itemName bold ItemNameStyle">
                    <span> {currentItem.name} </span>
                  </div>

                  <Description small={true} text={currentItem.description} />
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="modal-b">
                {this.state.addingToCart === false ? (
                  <div className="row">
                    <div
                      className="col-md-12 col-sm-12 col-xs-12 addEditItemPopup"
                      ref="modifierParentContainer"
                    >
                      <div className="col-md-4 col-lg-4 col-xs-12 col-sm-12 separate-container">
                        <ItemImage
                          switchModal={() => {}}
                          imageLink={itemImageData.url}
                          imageName={itemImageData.imageName}
                          imagePresent={itemImageData.imagePresent}
                          outOfStock={itemImageData.outOfStock}
                          isPopUp={true}
                        />
                        {itemImageData.imagePresent !== 'N' ? <br /> : null}
                        {nutritionList.length ? (
                          <div className="itemCaloriesProtein">
                            {getNutritionHeader(nutritionList)}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <NutritionalIcon
                              type="heart"
                              status={currentItem.heart_healthy}
                            />
                            <NutritionalIcon
                              type="gluten"
                              status={currentItem.contains_gluten}
                            />
                            <NutritionalIcon
                              type="dairy"
                              status={currentItem.contains_dairy}
                            />
                            <br />
                          </div>
                        ) : (
                          <div className="text-muted font-small text-center">
                            <FormattedMessage
                              id="nutritionNotAvailable"
                              defaultMessage={defaultMsg.nutritionNotAvailable}
                            />
                          </div>
                        )}

                        {nutritionList.length ? (
                          <div
                            className="itemNutritionButton"
                            onClick={() => this.switchNutritionPanel()}
                          >
                            {this.state.nutritionPanelStatus
                              ? this.props.intl.formatMessage({
                                  id: 'hideNutritionInfo',
                                  defaultMessage: defaultMsg.hideNutritionInfo,
                                })
                              : this.props.intl.formatMessage({
                                  id: 'viewNutritionInfo',
                                  defaultMessage: defaultMsg.viewNutritionInfo,
                                })}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-8 col-sm-12 col-lg-8 col-xs-12">
                        <div className="wrapper-class">
                          {this.state.loadingDetour ? (
                            <div className="loading-detour">
                              <MdLoaderTheme size={28} />
                            </div>
                          ) : null}
                          {currentItem.use_pizza_creator ? (
                            <PizzaCreatorModifiers
                              pizzaCreator={currentItem.pizza_creator}
                              handleModifierChange={
                                this.handlePizzaCreatorModifierChange
                              }
                              scrollBack={this.state.scrollBack}
                              scrollType={this.state.scrollType}
                              ref="modifierList"
                            />
                          ) : (
                            <ListModifiers
                              handleModifierChange={this.handleModifierChange}
                              currentItem={currentItem}
                              scrollBack={this.state.scrollBack}
                              editCart={this.props.editCart}
                              ref="modifierList"
                              scrollType={this.state.scrollType}
                              clickedItemIdList={this.state.clickedItemIdList}
                              modifierParentContainer={
                                this.refs.modifierParentContainer
                              }
                              addingToCart={this.state.addingToCart}
                              onscrollInPopup={(e, modifier) =>
                                this.onscrollInPopup(e, modifier)
                              }
                              specialInstructionsChange={
                                this.specialInstructionsChange
                              }
                              restrictSubmit={() => this.restrictSubmit}
                              specialInstructionRef={
                                this.state.specialInstructionId
                              }
                              defaultSpecialInstructions={
                                this.props.currentItem.specialInstruction
                              }
                            />
                          )}
                        </div>
                      </div>
                      {this.state.nutritionPanelStatus ? (
                        <NutritionPannel
                          currentItem={this.props.currentItem}
                          header={this.props.intl.formatMessage({
                            id: 'ingredients',
                            defaultMessage: defaultMsg.ingredients,
                          })}
                        />
                      ) : null}
                    </div>
                  </div>
                ) : (
                  <div className="loaderAlignment">
                    <div className="loading">
                      <MdLoaderTheme />
                    </div>
                    <FormattedMessage
                      id="addingToCart"
                      defaultMessage={defaultMsg.addingToCart}
                    />
                  </div>
                )}
              </Modal.Body>
              <div className="col-md-12 spacer line-style " />
              <Modal.Footer>
                {this.state.addingToCart === false ? (
                  <div className="col-md-12 space">
                    {this.props.currentItem.isFromReorder &&
                    this.props.currentItem.isFromReorder === true ? (
                      <div>
                        <button
                          className="btn addToBagButton olo-client-theme-background itemEdit"
                          onClick={e => this.editItem(this.props.currentItem)}
                        >
                          <FormattedMessage
                            id="editItems"
                            defaultMessage={defaultMsg.editItems}
                          />
                        </button>
                        <div
                          className="stepperControls no-selection olo-client-theme-border olo-client-theme-color"
                          onClick={() => this.stepDown()}
                        >
                          <span className="numberAlign"> &#8211; </span>
                        </div>
                        <StepInput
                          numberofItems={this.state.numberofItems}
                          setNumberOfItems={count =>
                            this.setNumberOfItems(count)
                          }
                          parseCounter={(counter, filterZero) =>
                            this.parseCounter(counter, filterZero)
                          }
                          focusCounter={this.state.focusCounter}
                        />

                        <div
                          className="stepperControls numberAlignPlus no-selection olo-client-theme-border olo-client-theme-color"
                          onClick={() => this.stepUp()}
                        >
                          &#43;
                        </div>
                        <button
                          className="btn  addToBagButton olo-client-theme-background"
                          onClick={e => this.addToBag(e)}
                        >
                          {updateCurrentItem ? 
                            <FormattedMessage 
                              id="updateCartItem"
                              defaultMessage={defaultMsg.updateCartItem}
                            /> 
                          : 
                            <FormattedMessage
                              id="addToCart"
                              defaultMessage={defaultMsg.addToCart}
                            />
                          }{' '}
                          :
                          {parsePrice(
                            parseFloat(
                              parsePrice(this.props.currentItem.price, true)
                            ) * Number(this.state.numberofItems)
                          )}
                        </button>
                      </div>
                    ) : (
                      <div>
                        {this.state.enableReOrderBack === true ? (
                          <button
                            className="btn addToBagButton olo-client-theme-background itemEdit"
                            onClick={e => this.reOrderBack()}
                          >
                            <FormattedMessage
                              id="reorder_back"
                              defaultMessage="Back"
                            />
                          </button>
                        ) : null}
                        <div
                          className="stepperControls no-selection olo-client-theme-border olo-client-theme-color"
                          onClick={() => this.stepDown()}
                        >
                          <span className="numberAlign"> &#8211; </span>
                        </div>
                        <StepInput
                          numberofItems={this.state.numberofItems}
                          setNumberOfItems={count =>
                            this.setNumberOfItems(count)
                          }
                          parseCounter={(counter, filterZero) =>
                            this.parseCounter(counter, filterZero)
                          }
                          focusCounter={this.state.focusCounter}
                        />

                        <div
                          className="stepperControls numberAlignPlus no-selection olo-client-theme-border olo-client-theme-color"
                          onClick={() => this.stepUp()}
                        >
                          &#43;
                        </div>
                        <button
                          className="btn  addToBagButton olo-client-theme-background"
                          onClick={e => this.addToBag(e)}
                          disabled={!this.validate()}
                        >
                          {updateCurrentItem ? 
                            <FormattedMessage 
                              id="updateCartItem"
                              defaultMessage={defaultMsg.updateCartItem}
                            /> 
                          : 
                            <FormattedMessage
                              id="addToCart"
                              defaultMessage={defaultMsg.addToCart}
                            />
                          }{' '}
                          :
                          {parsePrice(
                            parseFloat(parsePrice(currentItem.price, true)) *
                              Number(this.state.numberofItems)
                          )}
                        </button>
                      </div>
                    )}
                  </div>
                ) : null}
              </Modal.Footer>
            </form>
          </SkyLight>
        </modal>
      </div>
    ) : null;
  }
}

AddItemPopup.propTypes = {
  intl: intlShape.isRequired,
};

function mapStateToProps(state) {
  return {
    tokenId: getTokenId(state),
    jwt: getJWT(state),
    dataname: getDataName(state),
    themeCode: state.dashboard.merchantDetails.lavu_togo_theme,
    reOrderData: state.dashboard.reOrderItemsData,
  };
}

export default connect(mapStateToProps)(injectIntl(AddItemPopup));



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/AddItemPopup.jsx